// extracted by mini-css-extract-plugin
export default {"chipRow":"AOiZuxq6AW6NbTquA1z7","chip":"iZxd_DK25GNMopO6HEqE","chipSelected":"A4eCQsEosnQc14_TVHaw"};